import type { ItemId, ItemStack } from "./types";

const STACK: Partial<Record<ItemId, number>> = {
  ration: 8,
  seed_root: 12,
  seed_bitter: 12,
  herb: 8,
  scrap: 20,
  cinder: 16,
  rope: 4,
  lantern_oil: 6,
  bandage: 6,
  note: 9,
  artifact: 1,
  strange_root: 6,
  survey_plate: 4,
};

export function stackMax(id: ItemId): number {
  return STACK[id] ?? 8;
}

export function addItem(bag: ItemStack[], item: ItemStack, cap = 16): boolean {
  if (item.n <= 0) return true;
  const max = stackMax(item.id);
  for (const s of bag) {
    if (s.id !== item.id) continue;
    if (item.meta && JSON.stringify(s.meta) !== JSON.stringify(item.meta)) continue;
    const room = max - s.n;
    if (room <= 0) continue;
    const take = Math.min(room, item.n);
    s.n += take;
    item.n -= take;
    if (item.n <= 0) return true;
  }
  if (bag.length >= cap) return item.n <= 0;
  bag.push({ id: item.id, n: item.n, meta: item.meta });
  item.n = 0;
  return true;
}

export function takeItem(bag: ItemStack[], id: ItemId, n = 1): boolean {
  let left = n;
  for (const s of bag) {
    if (s.id !== id) continue;
    const take = Math.min(s.n, left);
    s.n -= take;
    left -= take;
    if (left <= 0) break;
  }
  for (let i = bag.length - 1; i >= 0; i--) if (bag[i]!.n <= 0) bag.splice(i, 1);
  return left <= 0;
}

export function countItem(bag: ItemStack[], id: ItemId): number {
  return bag.reduce((n, s) => n + (s.id === id ? s.n : 0), 0);
}

export function cloneBag(bag: ItemStack[]): ItemStack[] {
  return bag.map((s) => ({ id: s.id, n: s.n, meta: s.meta ? { ...s.meta } : undefined }));
}

export const ITEM_NAME: Record<ItemId, string> = {
  ration: "jarred ration",
  seed_root: "root seed",
  seed_bitter: "bitter seed",
  herb: "field herb",
  scrap: "fence scrap",
  cinder: "well cinder",
  rope: "frayed rope",
  lantern_oil: "lantern oil",
  bandage: "linen wrap",
  note: "torn note",
  artifact: "unreadable thing",
  strange_root: "wrong root",
  survey_plate: "survey plate",
};
